module.exports = __webpack_public_path__ + "static/media/currentOrderIcon.218bdae6.svg";